import React, { useContext } from "react";

import { Navigate } from "react-router-dom";
import UserContext from "../../../context/UserContext/UserContext";
import EmptyOrganisation from "../EmptyOrganisation/EmptyOrganisation";
import MyOrganisation from "../MyOrganisation/MyOrganisation";
import { checkIsInternalTeam } from "../../../utils/functions/functions";

const HandleMyOrganisation = () => {
  const user = useContext(UserContext)[0];

  const isInternalTeam = checkIsInternalTeam(user.roles);

  if (isInternalTeam) {
    return <Navigate to="/organisations" replace />;
  }

  return user.organisation ? <MyOrganisation /> : <EmptyOrganisation />;
};

export default HandleMyOrganisation;
